/* DM • Panier : garde les suppléments (lignes _gpo_parent_product_group) alignés sur leur kit (_gpo_product_group).
   Kit retiré -> suppléments retirés. Quantité du kit changée -> suppléments à la même quantité.
   S'exécute au chargement et après tout appel /cart/add|change|update|clear (fetch ou XMLHttpRequest). Remplace la partie panier de Globo. */
(function () {
  'use strict';
  var busy = false, again = false;
  function cartUrl(u) { return typeof u === 'string' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(u); }
  function reconcile() {
    if (busy) { again = true; return; }
    busy = true;
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      var mains = {};
      cart.items.forEach(function (it) { var g = it.properties && it.properties._gpo_product_group; if (g) mains[g] = it; });
      // une requête par ligne, par identifiant exact de ligne (la mise à jour groupée retirait toutes les lignes d'un même supplément)
      var todo = [];
      cart.items.forEach(function (it) {
        var p = it.properties && it.properties._gpo_parent_product_group;
        if (!p) return;
        var parent = mains[p];
        var want = parent ? parent.quantity : 0;
        if (want !== it.quantity) todo.push({ id: it.key, quantity: want });
      });
      if (!todo.length) return false;
      return todo.reduce(function (chain, t) {
        return chain.then(function () { return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-DMR-Sync': '1' }, body: JSON.stringify(t) }).catch(function () {}); });
      }, Promise.resolve()).then(function () { return true; });
    }).then(function (changed) {
      busy = false;
      if (changed) {
        if (/^\/([a-z]{2}(-[a-z]{2})?\/)?cart\/?$/i.test(location.pathname)) { location.reload(); return; }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('dmr:cart-synced'));
      }
      if (again) { again = false; reconcile(); }
    }).catch(function () { busy = false; });
  }
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    var skip = init && init.headers && (init.headers['X-DMR-Sync'] || (typeof init.headers.get === 'function' && init.headers.get('X-DMR-Sync')));
    if (cartUrl(url) && !skip) p.then(function () { setTimeout(reconcile, 60); }, function () {});
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (cartUrl(url)) this.addEventListener('loadend', function () { setTimeout(reconcile, 60); });
    return origOpen.apply(this, arguments);
  };
  document.addEventListener('submit', function (e) {
    var f = e.target; if (f && f.action && cartUrl(f.action)) setTimeout(reconcile, 800);
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reconcile); else reconcile();
})();
